import createTableStore from "ds/components/Table/store/useTableStore";

import {
  MODULE_VERSION_SUBMODULES_NAME_ONLY_COLUMNS_CONFIG,
  MODULE_VERSION_SUBMODULES_TABLE_COLUMNS_CONFIG,
  MODULE_VERSION_SUBMODULES_TABLE_STORAGE_KEY,
} from "./constants";

const useModuleVersionSubmodulesTableStore = createTableStore({
  storageKey: MODULE_VERSION_SUBMODULES_TABLE_STORAGE_KEY,
  config: MODULE_VERSION_SUBMODULES_TABLE_COLUMNS_CONFIG,
});

// Shares the storage key with the full-column store: syncColumnsOrder drops the unknown
// INSTRUCTIONS id and mergeColumnsSizes ignores its width, so one key round-trips both configs.
export const useModuleVersionSubmodulesNameOnlyTableStore = createTableStore({
  storageKey: MODULE_VERSION_SUBMODULES_TABLE_STORAGE_KEY,
  config: MODULE_VERSION_SUBMODULES_NAME_ONLY_COLUMNS_CONFIG,
});

export default useModuleVersionSubmodulesTableStore;
